export function splitCommaSeparatedKeys(keys?: string): string[] {
  return keys?.split(',').filter(Boolean) ?? [];
}
